import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const EMPTY = { title: "", asset_type: "Vehicle", registration: "", description: "", depot: "", department: "", purchased_date: "", odometer: "" };
const FIELDS = [["registration", "Registration"], ["description", "Make / model / description"], ["depot", "Depot"], ["department", "Department"], ["odometer", "Mileage / hours"]];

export function AddAssetDialog({ open, onClose, onSaved }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.post("/vehicles", f);
      toast.success(`${r.data.title} added`);
      setF(EMPTY); onSaved(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not add"); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { onClose(); } }}>
      <DialogContent className="max-w-lg" data-testid="add-asset-dialog">
        <DialogHeader><DialogTitle>Add plant / transport</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2"><Label>Name *</Label><Input value={f.title} onChange={set("title")} placeholder="e.g. Van 7, Forklift 4" data-testid="add-asset-title" /></div>
          <div><Label>Type</Label>
            <select value={f.asset_type} onChange={set("asset_type")} className="w-full rounded-md border border-slate-200 px-3 py-2 text-sm" data-testid="add-asset-type">
              {["Vehicle", "Trailer", "Forklift", "Plant"].map((t) => <option key={t}>{t}</option>)}
            </select></div>
          <div><Label>Purchased</Label><Input type="date" value={f.purchased_date} onChange={set("purchased_date")} data-testid="add-asset-purchased" /></div>
          {FIELDS.map(([k, l]) => <div key={k} className={k === "description" ? "col-span-2" : ""}><Label>{l}</Label><Input value={f[k]} onChange={set(k)} data-testid={`add-asset-${k}`} /></div>)}
        </div>
        <p className="text-xs text-slate-500">Forklifts appear in the Forklift Check Sheet; trailers in the trailer inspection.</p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={save} disabled={busy || !f.title.trim()} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="add-asset-save">{busy ? "Adding…" : "Add"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
